import ReactiveRecord, { Model } from 'reactiverecord';

class AppSettings extends Model {
  static store = {
    singleton: true,
  };

  static routes = {
    index: ':prefix/app_settings',
  };
  static schema = {
    add_skills_onboarding: Boolean,
    bid_autocomplete: Boolean,
    hide_job_club: Boolean,
    jobs_spellcheck: Boolean,
    mom_eeo_survey: Boolean,
    paa_new_jobs: Boolean,
    paa_user_flow: Boolean,
    project_removal: Boolean,
    public_community_page: Boolean,
    public_jobs_page: Boolean,
    show_invite_dtc_talent: Boolean,
    nylas_login_details: Object,
    show_talent_clouds_ui: Boolean,
    subscriber_logo: Boolean,
    talent_dashboard_navigation: Boolean,
    talent_freelancer_pro: Boolean,
    video_calls: Boolean,
    join_ex_tx: Boolean,
    employer_signup_onboarding_flow: Boolean,
    employer_verification: Boolean,
    jobpost_helper_boxes: Boolean,
  };

  static allCachedListeners = [];
  static async allCached() {
    if (this.allCachedResult) {
      return this.allCachedResult;
    }
    if (this.allCachedRequestedAtLeastOnce) {
      return await new Promise(resolve =>
        this.allCachedListeners.push(resolve),
      );
    }
    this.allCachedRequestedAtLeastOnce = true;
    this.allCachedResult = await this.all();
    this.allCachedListeners.forEach(listener => listener(this.allCachedResult));
    return this.allCachedResult;
  }
}

export default ReactiveRecord.model('AppSettings', AppSettings);
